import {css} from "lit-element/lit-element.js";
export default css`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-icon,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
.color-white {
  color: #ffffff !important;
}

.bg-white {
  background-color: #ffffff !important;
}

.color-primary {
  color: var(--atlas-primary) !important;
}

.bg-primary {
  background-color: var(--atlas-primary) !important;
}

.color-primary-100 {
  color: var(--atlas-primary-100) !important;
}

.bg-primary-100 {
  background-color: var(--atlas-primary-100) !important;
}

.color-primary-200 {
  color: var(--atlas-primary-200) !important;
}

.bg-primary-200 {
  background-color: var(--atlas-primary-200) !important;
}

.color-primary-300 {
  color: var(--atlas-primary-300) !important;
}

.bg-primary-300 {
  background-color: var(--atlas-primary-300) !important;
}

.color-primary-400 {
  color: var(--atlas-primary-400) !important;
}

.bg-primary-400 {
  background-color: var(--atlas-primary-400) !important;
}

.color-primary-500 {
  color: var(--atlas-primary-500) !important;
}

.bg-primary-500 {
  background-color: var(--atlas-primary-500) !important;
}

.color-primary-600 {
  color: var(--atlas-primary-600) !important;
}

.bg-primary-600 {
  background-color: var(--atlas-primary-600) !important;
}

.color-primary-700 {
  color: var(--atlas-primary-700) !important;
}

.bg-primary-700 {
  background-color: var(--atlas-primary-700) !important;
}

.color-primary-800 {
  color: var(--atlas-primary-800) !important;
}

.bg-primary-800 {
  background-color: var(--atlas-primary-800) !important;
}

.color-primary-900 {
  color: var(--atlas-primary-900) !important;
}

.bg-primary-900 {
  background-color: var(--atlas-primary-900) !important;
}

.active-primary[active], .active-primary.active, .active-primary:active {
  background-color: var(--atlas-primary) !important;
  color: var(--atlas-contrast-primary) !important;
}

.color-secondary {
  color: var(--atlas-secondary) !important;
}

.bg-secondary {
  background-color: var(--atlas-secondary) !important;
}

.color-secondary-100 {
  color: var(--atlas-secondary-100) !important;
}

.bg-secondary-100 {
  background-color: var(--atlas-secondary-100) !important;
}

.color-secondary-200 {
  color: var(--atlas-secondary-200) !important;
}

.bg-secondary-200 {
  background-color: var(--atlas-secondary-200) !important;
}

.color-secondary-300 {
  color: var(--atlas-secondary-300) !important;
}

.bg-secondary-300 {
  background-color: var(--atlas-secondary-300) !important;
}

.color-secondary-400 {
  color: var(--atlas-secondary-400) !important;
}

.bg-secondary-400 {
  background-color: var(--atlas-secondary-400) !important;
}

.color-secondary-500 {
  color: var(--atlas-secondary-500) !important;
}

.bg-secondary-500 {
  background-color: var(--atlas-secondary-500) !important;
}

.color-secondary-600 {
  color: var(--atlas-secondary-600) !important;
}

.bg-secondary-600 {
  background-color: var(--atlas-secondary-600) !important;
}

.color-secondary-700 {
  color: var(--atlas-secondary-700) !important;
}

.bg-secondary-700 {
  background-color: var(--atlas-secondary-700) !important;
}

.color-secondary-800 {
  color: var(--atlas-secondary-800) !important;
}

.bg-secondary-800 {
  background-color: var(--atlas-secondary-800) !important;
}

.color-secondary-900 {
  color: var(--atlas-secondary-900) !important;
}

.bg-secondary-900 {
  background-color: var(--atlas-secondary-900) !important;
}

.active-secondary[active], .active-secondary.active, .active-secondary:active {
  background-color: var(--atlas-primary) !important;
  color: var(--atlas-contrast-primary) !important;
}

.color-success {
  color: var(--atlas-success) !important;
}

.bg-success {
  background-color: var(--atlas-success) !important;
}

.color-success-100 {
  color: var(--atlas-success-100) !important;
}

.bg-success-100 {
  background-color: var(--atlas-success-100) !important;
}

.color-success-200 {
  color: var(--atlas-success-200) !important;
}

.bg-success-200 {
  background-color: var(--atlas-success-200) !important;
}

.color-success-300 {
  color: var(--atlas-success-300) !important;
}

.bg-success-300 {
  background-color: var(--atlas-success-300) !important;
}

.color-success-400 {
  color: var(--atlas-success-400) !important;
}

.bg-success-400 {
  background-color: var(--atlas-success-400) !important;
}

.color-success-500 {
  color: var(--atlas-success-500) !important;
}

.bg-success-500 {
  background-color: var(--atlas-success-500) !important;
}

.color-success-600 {
  color: var(--atlas-success-600) !important;
}

.bg-success-600 {
  background-color: var(--atlas-success-600) !important;
}

.color-success-700 {
  color: var(--atlas-success-700) !important;
}

.bg-success-700 {
  background-color: var(--atlas-success-700) !important;
}

.color-success-800 {
  color: var(--atlas-success-800) !important;
}

.bg-success-800 {
  background-color: var(--atlas-success-800) !important;
}

.color-success-900 {
  color: var(--atlas-success-900) !important;
}

.bg-success-900 {
  background-color: var(--atlas-success-900) !important;
}

.active-success[active], .active-success.active, .active-success:active {
  background-color: var(--atlas-success) !important;
  color: var(--atlas-contrast-success) !important;
}

.color-warning {
  color: var(--atlas-warning) !important;
}

.bg-warning {
  background-color: var(--atlas-warning) !important;
}

.color-warning-100 {
  color: var(--atlas-warning-100) !important;
}

.bg-warning-100 {
  background-color: var(--atlas-warning-100) !important;
}

.color-warning-200 {
  color: var(--atlas-warning-200) !important;
}

.bg-warning-200 {
  background-color: var(--atlas-warning-200) !important;
}

.color-warning-300 {
  color: var(--atlas-warning-300) !important;
}

.bg-warning-300 {
  background-color: var(--atlas-warning-300) !important;
}

.color-warning-400 {
  color: var(--atlas-warning-400) !important;
}

.bg-warning-400 {
  background-color: var(--atlas-warning-400) !important;
}

.color-warning-500 {
  color: var(--atlas-warning-500) !important;
}

.bg-warning-500 {
  background-color: var(--atlas-warning-500) !important;
}

.color-warning-600 {
  color: var(--atlas-warning-600) !important;
}

.bg-warning-600 {
  background-color: var(--atlas-warning-600) !important;
}

.color-warning-700 {
  color: var(--atlas-warning-700) !important;
}

.bg-warning-700 {
  background-color: var(--atlas-warning-700) !important;
}

.color-warning-800 {
  color: var(--atlas-warning-800) !important;
}

.bg-warning-800 {
  background-color: var(--atlas-warning-800) !important;
}

.color-warning-900 {
  color: var(--atlas-warning-900) !important;
}

.bg-warning-900 {
  background-color: var(--atlas-warning-900) !important;
}

.active-warning[active], .active-warning.active, .active-warning:active {
  background-color: var(--atlas-warning) !important;
  color: var(--atlas-contrast-warning) !important;
}

.color-danger {
  color: var(--atlas-danger) !important;
}

.bg-danger {
  background-color: var(--atlas-danger) !important;
}

.color-danger-100 {
  color: var(--atlas-danger-100) !important;
}

.bg-danger-100 {
  background-color: var(--atlas-danger-100) !important;
}

.color-danger-200 {
  color: var(--atlas-danger-200) !important;
}

.bg-danger-200 {
  background-color: var(--atlas-danger-200) !important;
}

.color-danger-300 {
  color: var(--atlas-danger-300) !important;
}

.bg-danger-300 {
  background-color: var(--atlas-danger-300) !important;
}

.color-danger-400 {
  color: var(--atlas-danger-400) !important;
}

.bg-danger-400 {
  background-color: var(--atlas-danger-400) !important;
}

.color-danger-500 {
  color: var(--atlas-danger-500) !important;
}

.bg-danger-500 {
  background-color: var(--atlas-danger-500) !important;
}

.color-danger-600 {
  color: var(--atlas-danger-600) !important;
}

.bg-danger-600 {
  background-color: var(--atlas-danger-600) !important;
}

.color-danger-700 {
  color: var(--atlas-danger-700) !important;
}

.bg-danger-700 {
  background-color: var(--atlas-danger-700) !important;
}

.color-danger-800 {
  color: var(--atlas-danger-800) !important;
}

.bg-danger-800 {
  background-color: var(--atlas-danger-800) !important;
}

.color-danger-900 {
  color: var(--atlas-danger-900) !important;
}

.bg-danger-900 {
  background-color: var(--atlas-danger-900) !important;
}

.active-danger[active], .active-danger.active, .active-danger:active {
  background-color: var(--atlas-danger) !important;
  color: var(--atlas-contrast-danger) !important;
}

.color-highlight {
  color: var(--atlas-highlight) !important;
}

.bg-highlight {
  background-color: var(--atlas-highlight) !important;
}

.color-highlight-100 {
  color: var(--atlas-highlight-100) !important;
}

.bg-highlight-100 {
  background-color: var(--atlas-highlight-100) !important;
}

.color-highlight-200 {
  color: var(--atlas-highlight-200) !important;
}

.bg-highlight-200 {
  background-color: var(--atlas-highlight-200) !important;
}

.color-highlight-300 {
  color: var(--atlas-highlight-300) !important;
}

.bg-highlight-300 {
  background-color: var(--atlas-highlight-300) !important;
}

.color-highlight-400 {
  color: var(--atlas-highlight-400) !important;
}

.bg-highlight-400 {
  background-color: var(--atlas-highlight-400) !important;
}

.color-highlight-500 {
  color: var(--atlas-highlight-500) !important;
}

.bg-highlight-500 {
  background-color: var(--atlas-highlight-500) !important;
}

.color-highlight-600 {
  color: var(--atlas-highlight-600) !important;
}

.bg-highlight-600 {
  background-color: var(--atlas-highlight-600) !important;
}

.color-highlight-700 {
  color: var(--atlas-highlight-700) !important;
}

.bg-highlight-700 {
  background-color: var(--atlas-highlight-700) !important;
}

.color-highlight-800 {
  color: var(--atlas-highlight-800) !important;
}

.bg-highlight-800 {
  background-color: var(--atlas-highlight-800) !important;
}

.color-highlight-900 {
  color: var(--atlas-highlight-900) !important;
}

.bg-highlight-900 {
  background-color: var(--atlas-highlight-900) !important;
}

.active-highlight[active], .active-highlight.active, .active-highlight:active {
  background-color: var(--atlas-highlight) !important;
  color: var(--atlas-contrast-highlight) !important;
}

.color-info {
  color: var(--atlas-info) !important;
}

.bg-info {
  background-color: var(--atlas-info) !important;
}

.color-info-100 {
  color: var(--atlas-info-100) !important;
}

.bg-info-100 {
  background-color: var(--atlas-info-100) !important;
}

.color-info-200 {
  color: var(--atlas-info-200) !important;
}

.bg-info-200 {
  background-color: var(--atlas-info-200) !important;
}

.color-info-300 {
  color: var(--atlas-info-300) !important;
}

.bg-info-300 {
  background-color: var(--atlas-info-300) !important;
}

.color-info-400 {
  color: var(--atlas-info-400) !important;
}

.bg-info-400 {
  background-color: var(--atlas-info-400) !important;
}

.color-info-500 {
  color: var(--atlas-info-500) !important;
}

.bg-info-500 {
  background-color: var(--atlas-info-500) !important;
}

.color-info-600 {
  color: var(--atlas-info-600) !important;
}

.bg-info-600 {
  background-color: var(--atlas-info-600) !important;
}

.color-info-700 {
  color: var(--atlas-info-700) !important;
}

.bg-info-700 {
  background-color: var(--atlas-info-700) !important;
}

.color-info-800 {
  color: var(--atlas-info-800) !important;
}

.bg-info-800 {
  background-color: var(--atlas-info-800) !important;
}

.color-info-900 {
  color: var(--atlas-info-900) !important;
}

.bg-info-900 {
  background-color: var(--atlas-info-900) !important;
}

.active-info[active], .active-info.active, .active-info:active {
  background-color: var(--atlas-info) !important;
  color: var(--atlas-contrast-info) !important;
}

.gap-0 {
  gap: 0 !important;
}

.column-gap-0 {
  column-gap: 0 !important;
}

.row-gap-0 {
  row-gap: 0 !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.gap-1 {
  gap: 0.25rem !important;
}

.column-gap-1 {
  column-gap: 0.25rem !important;
}

.row-gap-1 {
  row-gap: 0.25rem !important;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

.mb-1 {
  margin-bottom: 0.25rem !important;
}

.gap-2 {
  gap: 0.5rem !important;
}

.column-gap-2 {
  column-gap: 0.5rem !important;
}

.row-gap-2 {
  row-gap: 0.5rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.gap-3 {
  gap: 0.75rem !important;
}

.column-gap-3 {
  column-gap: 0.75rem !important;
}

.row-gap-3 {
  row-gap: 0.75rem !important;
}

.mt-3 {
  margin-top: 0.75rem !important;
}

.mb-3 {
  margin-bottom: 0.75rem !important;
}

.gap-4 {
  gap: 1rem !important;
}

.column-gap-4 {
  column-gap: 1rem !important;
}

.row-gap-4 {
  row-gap: 1rem !important;
}

.mt-4 {
  margin-top: 1rem !important;
}

.mb-4 {
  margin-bottom: 1rem !important;
}

.gap-5 {
  gap: 1.25rem !important;
}

.column-gap-5 {
  column-gap: 1.25rem !important;
}

.row-gap-5 {
  row-gap: 1.25rem !important;
}

.mt-5 {
  margin-top: 1.25rem !important;
}

.mb-5 {
  margin-bottom: 1.25rem !important;
}

.gap-6 {
  gap: 1.5rem !important;
}

.column-gap-6 {
  column-gap: 1.5rem !important;
}

.row-gap-6 {
  row-gap: 1.5rem !important;
}

.mt-6 {
  margin-top: 1.5rem !important;
}

.mb-6 {
  margin-bottom: 1.5rem !important;
}

.gap-7 {
  gap: 2rem !important;
}

.column-gap-7 {
  column-gap: 2rem !important;
}

.row-gap-7 {
  row-gap: 2rem !important;
}

.mt-7 {
  margin-top: 2rem !important;
}

.mb-7 {
  margin-bottom: 2rem !important;
}

.gap-8 {
  gap: 2.5rem !important;
}

.column-gap-8 {
  column-gap: 2.5rem !important;
}

.row-gap-8 {
  row-gap: 2.5rem !important;
}

.mt-8 {
  margin-top: 2.5rem !important;
}

.mb-8 {
  margin-bottom: 2.5rem !important;
}

.gap-9 {
  gap: 3rem !important;
}

.column-gap-9 {
  column-gap: 3rem !important;
}

.row-gap-9 {
  row-gap: 3rem !important;
}

.mt-9 {
  margin-top: 3rem !important;
}

.mb-9 {
  margin-bottom: 3rem !important;
}

.container {
  flex: 1 1 100%;
  box-sizing: border-box;
  padding: 0.5rem 1rem 1rem;
  width: 100%;
  margin-right: auto;
  margin-left: auto;
}
@media screen and (min-width: 576px) {
  .container {
    max-width: 540px;
  }
}
@media screen and (min-width: 768px) {
  .container {
    max-width: 720px;
  }
}
@media screen and (min-width: 992px) {
  .container {
    max-width: 960px;
  }
}
@media screen and (min-width: 1200px) {
  .container {
    max-width: 1140px;
  }
}
@media screen and (min-width: 1400px) {
  .container {
    max-width: 1320px;
  }
}

:host {
  display: inline-flex;
  width: 100%;
}

.page-section {
  position: relative;
  z-index: 1;
  width: 100%;
  background-color: var(--atlas-light);
}
.page-section.with-background {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.page-section.padding-none {
  padding: 0;
}
.page-section.padding-sm {
  padding: 2rem 0;
}
.page-section.padding-md {
  padding: 3rem 0;
}
.page-section.padding-lg {
  padding: 4rem 0;
}
.page-section.white {
  background-color: #ffffff;
}

.container {
  padding: 0;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
